<template>
  <div>
    <ActionsMenu
      class="actions-menu"
      :actions="actions"
      :options="{
        theme: 'light tooltip-standard-size'
      }"
      @schedule-customer="toggleScheduleModal"
      @archive-customer="handleArchiveClicked"
      @unarchive-customer="handleArchiveClicked"
    />
    <schedule-job-modal
      v-if="scheduleModal"
      :address="address"
      :customer="customer"
      :link="scheduleLink"
      @hide-modal="toggleScheduleModal"
    ></schedule-job-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import ActionsMenu from "@/components/ActionsMenu.vue";
import ScheduleJobModal from "@/ScheduleModal/ScheduleJobModal.vue";

export default {
  components: {
    ActionsMenu,
    ScheduleJobModal
  },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
    addressInvalid: {
      type: Boolean,
      default: false
    },
    address: {
      type: Object,
      default: null
    },
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scheduleModal: false
    };
  },
  computed: {
    actions() {
      return [
        {
          label: "Schedule",
          icon: "fa-regular fa-calendar-plus",
          eventName: "schedule-customer",
          className: "menu-item",
          disabled: !this.canSchedule
        },
        {
          label: "Archive",
          icon: "fa-regular fa-archive",
          eventName: "archive-customer",
          className: "menu-item",
          visible: this.links.customer_archive
        },
        {
          label: "Unarchive",
          icon: "fa-regular fa-box-open",
          eventName: "unarchive-customer",
          className: "menu-item",
          visible: this.links.customer_unarchive
        }
      ];
    },
    canSchedule() {
      return (
        this.address &&
        !this.addressInvalid &&
        this.customer.phone &&
        this.customer.email &&
        this.links.job_create
      );
    },
    scheduleLink() {
      return this.links.job_create;
    }
  },
  methods: {
    ...mapActions(["updateCustomerArchiveStatus"]),
    handleArchiveClicked() {
      if (!this.customer.archived && this.customer.has_subs) {
        EventBus.$emit("confirm-archive", this.handleArchiveAction);
        return;
      }

      if (this.customer.archived && this.customer.parent?.archived) {
        EventBus.$emit("confirm-unarchive");
        return;
      }

      this.handleArchiveAction();
    },
    handleArchiveAction() {
      const action_url =
        this.links.customer_archive || this.links.customer_unarchive;
      const action = this.customer.archived ? "Unarchived" : "Archived";
      this.updateCustomerArchiveStatus({ action_url }).then(() => {
        const fullName = `${this.customer.first_name} ${this.customer.last_name}`;
        window.notify.success(
          `Customer ${fullName} was successfully ${action}`
        );
        EventBus.$emit("refresh-customer-table");
      });
    },
    toggleScheduleModal() {
      this.scheduleModal = !this.scheduleModal;
    }
  }
};
</script>

<style lang="scss"></style>
